import { render, staticRenderFns } from "./homeSlider.vue?vue&type=template&id=866cd01a"
import script from "./homeSlider.vue?vue&type=script&lang=js"
export * from "./homeSlider.vue?vue&type=script&lang=js"
import style0 from "./homeSlider.vue?vue&type=style&index=0&id=866cd01a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports